import React from "react";
import LoginForm from "./common/LoginForm";
import { connect } from "react-redux";
import {
  DetailsList,
  Spinner,
  SpinnerSize,
  Dialog,
  DialogFooter,
  ChoiceGroup,
  Button,
  ButtonType,
  CheckboxVisibility,
  TextField,
  DatePicker,
  Label,
  Dropdown,
  TagPicker,
  DetailsListLayoutMode,
  ConstrainMode,
  DefaultButton,
  PrimaryButton,
  IconButton,
} from "office-ui-fabric-react";
import * as axios from "../axios/users";
import { browserHistory } from "react-router";

import imgCity from "./imgs/city.jpg";
import imgLogo from "./imgs/login-logo.png";
import request from "axios";
import config from "../config";
import StatusBar from "./common/StatusBar";
import _ from "lodash";

export class ManageUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false,
      isLoading: false,
      showDialogDelete: false,
      showComments: false,
      showReminderDate: false,
      columns: columns,
      data: {},
    };
  }

  componentDidMount() {
    this.props.dispatch(axios.list(true));
  }

  close() {
    this.setState({
      showDialog: false,
      data: {},
    });
  }

  save() {
    var user = this.state.data;
    var zipCodes = user.zipCodes || "";
    this.props.dispatch(
      axios.update({
        _id: user._id,
        managerId: null,
        deleted: true,
        zipCodes: "",
      })
    );

    zipCodes = zipCodes
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e);

    if (zipCodes && zipCodes.length > 0) {
      request
        .post(`${config.apiUrl}/zipcode/reassign`, {
          zipCodes: zipCodes,
        })
        .then(() => {})
        .catch((e) => alert("Error"));
    }

    this.setState({
      isLoading: true,
    });
    setTimeout(() => {
      this.setState({
        showDialog: false,
        isLoading: false,
      });
      this.rowSelected = null;
    }, 1000);
  }
  active() {
    var user = this.state.data;
    var zipCodes = user.zipCodes || "";
    this.props.dispatch(
      axios.update({
        _id: user._id,
        managerId: null,
        deleted: false,
        zipCodes: "",
      })
    );

    this.setState({
      isLoading: true,
    });
    setTimeout(() => {
      this.setState({
        showDialog: false,
        isLoading: false,
      });
      this.rowSelected = null;
    }, 1000);
  }

  show(e) {
    this.rowSelected = e;
    this.setState({
      showDialog: true,
      data: e,
    });
  }

  render() {
    var columns = this.state.columns;
    var users = this.props.users;
    if (this.props.auth.user.accountType == "admin") {
      var processCollum = columns.find((e) => e.key == "action");
      processCollum.onRender = (e) => {
        return (
          <div>
            <IconButton
              iconProps={{ iconName: "Edit" }}
              className="tbl-btn"
              onClick={() => this.show(e)}
            />
          </div>
        );
      };
    } else {
      columns = columns.filter((e) => e.key != "action");
    }

    return (
      <div style={{ margin: 10 }}>
        {users.error ? (
          <div className="ms-fontColor-red">Error</div>
        ) : !users.data ? (
          <Spinner size={SpinnerSize.large} />
        ) : (
          <div style={{ marginBottom: 30 }}>
            <DetailsList
              items={users.data}
              columns={columns}
              checkboxVisibility={CheckboxVisibility.hidden}
              style={{ fontSize: 14 }}
            />
            <StatusBar>
              <span>Total: {users.data.length}</span>
              {this.state.data._id && (
                <span>
                  {" "}
                  | Selected: #{users.data.indexOf(this.state.data) + 1} -{" "}
                  {`${this.state.data.fname} ${this.state.data.lname}`}{" "}
                </span>
              )}
            </StatusBar>
          </div>
        )}
        {this.state.data._id && (
          <Dialog
            isOpen={this.state.showDialog}
            title="Delete account"
            isBlocking={false}
            closeButtonAriaLabel="Close"
            containerClassName="info-list-modal"
            onDismiss={() => this.close()}
          >
            <div className="ms-Grid">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-u-md12">
                  <TextField
                    label="Name"
                    value={this.state.data.fname + " " + this.state.data.lname}
                    disabled={true}
                  />
                </div>
                <div className="ms-Grid-col ms-u-md12">
                  <TextField
                    label="Email"
                    value={this.state.data.email}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <DialogFooter>
              {!this.state.data.deleted && (
                <PrimaryButton onClick={() => this.save()}>
                  {this.state.isLoading ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Spinner size={SpinnerSize.xSmall} />
                      {" Deleting..."}
                    </div>
                  ) : (
                    <span>Delete this account</span>
                  )}
                </PrimaryButton>
              )}
              {this.state.data.deleted && (
                <PrimaryButton onClick={() => this.active()}>
                  {this.state.isLoading ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Spinner size={SpinnerSize.xSmall} />
                      {" Activating..."}
                    </div>
                  ) : (
                    <span>Activate this account</span>
                  )}
                </PrimaryButton>
              )}
              <DefaultButton onClick={() => this.close()}>Cancel</DefaultButton>
            </DialogFooter>
          </Dialog>
        )}
      </div>
    );
  }
}

export default connect((state) => ({
  auth: state.auth,
  users: state.users,
  customer: state.customer,
}))(ManageUser);
const accountTypeLabel = {
  staff: "Lead Generator",
  "central-user": "Central User",
  closer: "Closer",
  manager: "Manager",
  admin: "Admin",
};

const columns = [
  {
    key: "fname",
    name: "First name",
    fieldName: "fname",
    minWidth: 50,
    maxWidth: 120,
  },
  {
    key: "lname",
    name: "Last name",
    fieldName: "lname",
    minWidth: 50,
    maxWidth: 120,
  },
  {
    key: "email",
    name: "Email address",
    fieldName: "email",
    minWidth: 250,
    maxWidth: 250,
  },
  // {
  //     key: 'zipCodes',
  //     name: 'Zip Codes',
  //     fieldName: 'zipCodes',
  //     isMultiline: true,
  //     onRender: (item) => {
  //         return (item
  //             .zipCodes || '')
  //             .split(',')
  //             .map(e => e.trim())
  //             .join(', ');
  //     }
  // },
  {
    key: "role",
    name: "Role",
    fieldName: "accountType",
    minWidth: 150,
    maxWidth: 150,
    onRender: (item) => {
      return accountTypeLabel[item.accountType];
    },
  },
  {
    key: "deleted",
    name: "Deleted",
    fieldName: "deleted",
    minWidth: 80,
    maxWidth: 80,
    onRender: (item) => {
      return item.deleted ? "Deleted" : "";
    },
  },
  {
    key: "action",
    name: "",
    fieldName: "action",
    minWidth: 80,
    maxWidth: 80,
  },
];



// WEBPACK FOOTER //
// ./client/components/ManageUser.js